import React, { useState } from "react";
import LeftNavBar from "../components/LeftNavBar/LeftNavBar";
import Header from "../components/header/header";
import { Outlet } from "react-router-dom";
import AppRoute from "../routes";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Layout.css";
import ApproveRejectModal from "../components/StatusModal/ApproveRejectModal/ApproveRejectModal";
function Layout() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [chatBot, setChatBot] = useState(false);
  const toggleNavbar = () => {
    setIsNavOpen(!isNavOpen);
  };

  const toggleMobileNavbar = () => {
    setIsMobileNavOpen(true);
  };

  const CloseMonileLeftNavbar = () => {
    setIsMobileNavOpen(false);
  };

  // ✅ Handler for switching navbars
  const handleNavSwitch = (type) => {
    if (type === "chatbot") {
      setChatBot(true);
     // setIsNavOpen(true); // open navbar
    } else if (type === "blog") {
      setChatBot(false);
     // setIsNavOpen(true); // open navbar
    }
  };
  return (
    <div className="layout">
      <Header
        onMenuClick={toggleNavbar}
        isNavOpen={isNavOpen}
        onMobileMenuClick={toggleMobileNavbar}
        isMobileNavOpen={isMobileNavOpen}
        onNavSwitch={handleNavSwitch}
      />
      <div
        className={`main_wraper ${
          isNavOpen ? "shrink_main_wraper" : "main_wraper"
        }`}
      >
        <Outlet />
      </div>

      {!chatBot &&
      <LeftNavBar
        isOpen={isNavOpen}
        isMobileOpen={isMobileNavOpen}
        setIsMobileNavOpen={setIsMobileNavOpen}
        onMobileNavHide={CloseMonileLeftNavbar}
      />}
    </div>
  );
}

export default Layout;
